import styled from 'styled-components';

export const CommandChipsContainer = styled.div`
  padding: 0 12px 12px 12px;
  display: flex;
  overflow-x: auto;
`;

export const CommandChip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.background};
  color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
  border: 1px solid ${({ theme }) => theme.colorPalette.turquoise.dark};
  border-radius: 16px;
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  cursor: pointer;
  margin-right: 8px;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.dark : theme.colorPalette.turquoise.accent2};
  }
`;
